function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return "a" + shadowSelector + " {color: var(--i18n-link-link-color, var(--ads-link-color, #0176D3));}a:hover" + shadowSelector + " {color: var(--i18n-link-link-hover-color, var(--sds-g-color-palette-blue-20, #032d60));}span" + shadowSelector + " {color: var(--i18n-link-text-color, var(--ads-text-color, rgb(35, 51, 93)));}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];